import React, { useState, useEffect } from 'react';
import './KebabGallery.css';

const KebabGallery = () => {
  const [filter, setFilter] = useState('all');
  const [isLoading, setIsLoading] = useState(true);

  const menuItems = [
  {
    id: 1,
    src: '/image/1.jpg',
    alt: 'Döner Normal',
    category: 'döner',
    price: '6,00 €',
    title: 'Döner Normal',
    description: 'Fladenbrot mit Fleisch, Salat und Soßen'
  },
  {
    id: 2,
    src: '/image/2.jpg',
    alt: 'Döner Dürüm',
    category: 'döner',
    price: '7,00 €',
    title: 'Döner Dürüm',
    description: 'Flachbrot mit Fleisch, Salat und soßen'
  },
  {
    id: 3,
    src: '/image/3.jpg',
    alt: 'Döner Ohne Salat',
    category: 'döner',
    price: '6,00 €',
    title: 'Döner Ohne Salat',
    description: 'Fladenbrot mit Fleisch und Soßen'
  },
  {
    id: 4,
    src: '/image/4.jpg',
    alt: 'Döner Box',
    category: 'döner',
    price: '6,00 €',
    title: 'Döner Box',
    description: 'Box mit Pommes oder Salat und Soßen'
  },
  {
    id: 5,
    src: '/image/5.jpg',
    alt: 'Döner Teller',
    category: 'teller',
    price: '10,00 €',
    title: 'Döner Teller',
    description: 'Döner-Fleisch mit Pommes, Salat und Soßen'
  },
  {
    id: 6,
    src: '/image/6.jpg',
    alt: 'Mittleres Pommes Schälchen',
    category: 'teller',
    price: '8,00 €',
    title: 'Mittleres Pommes Schälchen',
    description: 'Pommes mit Döner-Fleisch und Soßen'
  },
  {
    id: 7,
    src: '/image/7.jpg',
    alt: 'Großes Pommes Schälchen',
    category: 'teller',
    price: '11,00 €',
    title: 'Großes Pommes Schälchen',
    description: 'Pommes mit Döner-Fleisch und Soßen'
  },
  {
    id: 8,
    src: '/image/8.jpg',
    alt: 'Lahmacun',
    category: 'pizza',
    price: '6,50 €',
    title: 'Lahmacun',
    description: 'Lahmacun mit Salat und Soßen'
  },
  {
    id: 9,
    src: '/image/9.jpg',
    alt: 'Lahmacun Mit Döner',
    category: 'pizza',
    price: '8,00 €',
    title: 'Lahmacun Mit Döner',
    description: 'Lahmacun mit Döner-Fleisch, Salat und Soßen'
  },
  {
    id: 10,
    src: '/image/10.jpg',
    alt: 'Falafel Tasche',
    category: 'vegetarian',
    price: '5,00 €',
    title: 'Falafel Tasche',
    description: 'Fladenbrot mit Kichererbsenbuletten, Salat und Soßen'
  },
  {
    id: 11,
    src: '/image/11.jpg',
    alt: 'Falafel Dürüm',
    category: 'vegetarian',
    price: '6,00 €',
    title: 'Falafel Dürüm',
    description: 'Flachbrot mit Falafel (Kichererbsenbuletten), Salat und Soßen'
  },
  {
    id: 12,
    src: '/image/12.jpg',
    alt: 'Falafel Teller',
    category: 'vegetarian',
    price: '7,00 €',
    title: 'Falafel Teller',
    description: 'Falafel (Kichererbsenbuletten), Pommes, Salat und Soßen'
  },
  {
    id: 13,
    src: '/image/13.jpg',
    alt: 'Hähnchen Schnitzel',
    category: 'grill',
    price: '9,00 €',
    title: 'Hähnchen Schnitzel',
    description: 'mit Pommes, Salat und Soßen'
  },
  {
    id: 14,
    src: '/image/14.jpg',
    alt: 'Currywurst',
    category: 'grill',
    price: '7,00 €',
    title: 'Currywurst',
    description: 'mit Pommes und Röstzwiebel'
  },
  {
    id: 15,
    src: '/image/15.jpg',
    alt: 'Chicken-Nuggets',
    category: 'grill',
    price: '7,00 €',
    title: 'Chicken-Nuggets',
    description: '6 St. Nuggets mit Pommes und Soße'
  }
];


  const categories = [
    { key: 'all', label: 'Alle Speisen' },
    { key: 'döner', label: 'Döner' },
    { key: 'teller', label: 'Teller' },
    { key: 'grill', label: 'Grill Spezialitäten' },
    { key: 'pizza', label: 'Pide & Lahmacun' },
    { key: 'vegetarian', label: 'Vegetarisch' }
  ];

  const filteredItems = filter === 'all' 
    ? menuItems 
    : menuItems.filter(item => item.category === filter);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);


  const FloatingElement = ({ children, delay = 0, duration = 30, startX = 0 }) => (
    <div
      className="gallery-floating-element"
      style={{
        left: `${startX}%`,
        animationDuration: `${duration}s`,
        animationDelay: `${delay}s`,
      }}
    >
      {children}
    </div>
  );

  const FoodIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="text-amber-400 opacity-20">
      <path
        d="M12 2C13.1 2 14 2.9 14 4V8C14 9.1 13.1 10 12 10S10 9.1 10 8V4C10 2.9 10.9 2 12 2ZM21 9V7L15 3.5V6.5L21 9ZM3 9L9 6.5V3.5L3 7V9ZM12 12C15.86 12 19 10.21 19 8V10C19 12.21 15.86 14 12 14S5 12.21 5 10V8C5 10.21 8.14 12 12 12ZM12 16C15.86 16 19 14.21 19 12V14C19 16.21 15.86 18 12 18S5 16.21 5 14V12C5 14.21 8.14 16 12 16ZM12 20C15.86 20 19 18.21 19 16V18C19 20.21 15.86 22 12 22S5 20.21 5 18V16C5 18.21 8.14 20 12 20Z"
        fill="currentColor"
      />
    </svg>
  );

  return (
    <section className="kebab-gallery">
      {/* Floating Background Elements */}
      <FloatingElement delay={0} duration={40} startX={5}>
        <FoodIcon />
      </FloatingElement>
      <FloatingElement delay={10} duration={50} startX={85}>
        <FoodIcon />
      </FloatingElement>
      <FloatingElement delay={20} duration={45} startX={15}>
        <FoodIcon />
      </FloatingElement>
      <FloatingElement delay={30} duration={35} startX={75}>
        <FoodIcon />
      </FloatingElement>

      <div className="gallery-container">
        {/* Header Section */}
        <div className="gallery-header">
          <div className="gallery-title-section">
            <h2 className="gallery-main-title">
              <span className="title-line">UNSERE</span>
              <span className="title-line highlight">SPEISEKARTE</span>
            </h2>
            <p className="gallery-subtitle">
              Authentische türkische Küche - von traditionellen Döner bis zu modernen Interpretationen
            </p>
          </div>

          {/* Filter Buttons */}
          <div className="gallery-filters">
            {categories.map((category) => (
              <button
                key={category.key}
                className={`filter-btn ${filter === category.key ? 'active' : ''}`}
                onClick={() => setFilter(category.key)}
              >
                {category.label}
              </button>
            ))}
          </div>
        </div>

        {/* Gallery Grid */}
        <div className="gallery-grid">
          {isLoading ? (
            Array.from({ length: 9 }).map((_, index) => (
              <div key={index} className="gallery-item skeleton">
                <div className="skeleton-content">
                  <div className="skeleton-text"></div>
                  <div className="skeleton-text short"></div>
                  <div className="skeleton-text medium"></div>
                </div>
              </div>
            ))
          ) : (
            filteredItems.map((item, index) => (
              <div 
                key={item.id} 
                className="gallery-item"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="menu-card">
                  <div className="menu-card-header">
                    <h3 className="menu-title">{item.title}</h3>
                    <span className="menu-price">{item.price}</span>
                  </div>
                  <p className="menu-description">{item.description}</p>
                  <div className="menu-category-badge">{categories.find(cat => cat.key === item.category)?.label}</div>
                </div>
              </div>
            ))
          )}
        </div>

        {/* Call to Action */}
        <div className="gallery-cta">
          <h3 className="cta-title">Hunger bekommen?</h3>
          <p className="cta-description">
            Bestelle jetzt deine Lieblingsgerichte oder komm einfach vorbei
          </p>
          <div className="cta-buttons">
            <button 
              className="cta-btn primary"
              onClick={() => {
                  const target = document.querySelector('#contact');
                  if (target) {
                  target.scrollIntoView({ 
                      behavior: 'smooth',
                      block: 'start'
                  });
                  }
              }}
              >
              <span className="btn-text">JETZT BESTELLEN</span>
              </button>
              <button 
              className="cta-btn secondary"
              onClick={() => {
                  const target = document.querySelector('#contact');
                  if (target) {
                  target.scrollIntoView({ 
                      behavior: 'smooth',
                      block: 'start'
                  });
                  }
              }}
              >
              <span className="btn-text">JETZT ANRUFEN</span>
              </button>
          </div>
        </div>
      </div>

    </section>
  );
};

export default KebabGallery;